module.exports = __webpack_public_path__ + "static/desktop/img/typeset-tablet-photobook.df832e19.png";